import type { Modification } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Counts active modifications per group, excluding extras (which have their
 * own separate limits). Computed once from raw (unmerged) active modifications.
 */
export function getIncludedGroupCounts(activeModifications: Modification[]): GroupCounts {
  return activeModifications.reduce<GroupCounts>((counts, modification) => {
    const { isExtra, modificationGroupName, quantity } = modification;

    if (isExtra) {
      return counts;
    }

    const current = counts[modificationGroupName] ?? 0;

    return {
      ...counts,
      [modificationGroupName]: current + quantity,
    };
  }, {});
}

// ─── Types ───────────────────────────────────────────────────────────────────

type GroupCounts = Record<string, number>;
